// src/components/devices/DeviceAdder.js
import React,{ useContext,useEffect,useState } from 'react';
import { toast } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';
import { AppContext } from '../../context/AppContext';
import './DeviceAdder.css';

// Device form components for different device types
import ZigbeeDeviceForm from './deviceForms/ZigbeeDeviceForm';
import { useAuth } from '../../context/AuthContext';

const DeviceAdder = ({ onClose, onDeviceAdded }) => {
  const { refreshDevices } = useContext(AppContext);
  
  // Device type selection state - default to zigbee since it's the only option
  const [deviceType, setDeviceType] = useState('zigbee');
  const [isAdding, setIsAdding] = useState(false);
  const { apiRequest } = useAuth();
  const API_BASE_URL = '';
  const API_PATH = '/api';


  // Handle adding zigbee device through discovery
  const handleAddZigbeeDevice = async (zigbeeData) => {
    try {
      setIsAdding(true);
      
      // Enable Zigbee device discovery mode using new API
      const {response,data} = await apiRequest(`${API_BASE_URL}${API_PATH}/devices/zigbee/discovery/enable`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          timeout: zigbeeData.discoveryTimeout || 600,
        }),
      });

      if (!response.ok) {
        throw new Error(data.message || 'Failed to enable Zigbee discovery mode');
      }
      
      toast.success(`Zigbee discovery enabled for ${Math.round((zigbeeData.discoveryTimeout || 600) / 60)} minutes`);
      
      // After enabling discovery, refresh devices to see any new ones
      await refreshDevices();
      
      if (onDeviceAdded) onDeviceAdded();
      onClose();
    } catch (error) {
      console.error('Error enabling Zigbee discovery:', error);
      toast.error(`Failed to enable Zigbee discovery: ${error.message}`);
    } finally {
      setIsAdding(false);
    }
  };


  // Render the form based on selected device type
  const renderDeviceForm = () => {
    switch (deviceType) {
      case 'zigbee':
        return (
          <ZigbeeDeviceForm 
            onSubmit={handleAddZigbeeDevice} 
            onCancel={onClose}
            isAdding={isAdding}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="device-adder">
      <div className="adder-header">
        <h3>Add Zigbee Device</h3>
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      
      <div className="adder-content">
        {renderDeviceForm()}
      </div>
    </div>
  );
};

export default DeviceAdder;